import React, { useEffect, useState, type JSX } from "react";
import { CardContainer } from "../../components/Card/CardContainer";
import Text from "../../components/Text/Text";
import { AllCreditTab } from "./Tabs/AllCreditTab";
import moment from "moment";
import { convertBuddhistYear } from "../../utility/Formatter";
import {
  AllShopCreditLimitEntity_INIT,
  type AllShopCreditLimitEntity,
} from "../../entities/CreditLimitEntity";
import { getCountCredit } from "../../datasource/CreditLimitDatasource";
import { AllCreditTabNew } from "./Tabs/AllCreditTabNew";

function OrderCreditList() {
  const [shopCredit, setShopCredit] = useState<AllShopCreditLimitEntity>(
    AllShopCreditLimitEntity_INIT,
  );
  const [count, setCount] = useState<{ countAll: number; countTempCredit: number }>({
    countAll: 0,
    countTempCredit: 0,
  });
  const companyCode = JSON.parse(localStorage.getItem("company")!);

  useEffect(() => {
    const fetchCountCredit = async () => {
      try {
        await getCountCredit(companyCode?.companyCode).then((res) => {
          setCount(res);
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchCountCredit();
  }, []);

  return (
    <CardContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24,
        }}
      >
        <Text fontFamily='IBM Plex Sans Thai' fontSize={24} fontWeight={700}>
          วงเงินร้านค้า
        </Text>
        <Text fontFamily='Sarabun' fontSize={12} fontWeight={400}>
          {shopCredit.lastUpdate
            ? convertBuddhistYear.toBuddhistYear(
                moment(shopCredit.lastUpdate),
                "อัปเดตล่าสุดเมื่อ DD/MM/YYYY , HH:mm  ",
              )
            : undefined}
        </Text>
      </div>
      <AllCreditTabNew callBackData={(value) => setShopCredit(value)} />
    </CardContainer>
  );
}

export default OrderCreditList;
